import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    examPaperListLoading: false,
    examPaperListSuccess: null,
    examPaperListError: '',

    getExamPaperLoading: false,
    getExamPaperSuccess: null,
    getExamPaperError: '',
}

export const examPaperSlice = createSlice({
    name: 'ExamPaper',
    initialState, 
    reducers: {
        setExamPaperListLoading: (state) => {
            state.examPaperListLoading = true;
            state.examPaperListSuccess = null;
            state.examPaperListError = '';
        },
        setExamPaperListSuccess: (state, action) => {
            state.examPaperListLoading = false;
            state.examPaperListSuccess = action.payload;
            state.examPaperListError = '';
        },
        setExamPaperListError: (state, action) => {
            state.examPaperListLoading = false;
            state.examPaperListSuccess = null;
            state.examPaperListError = action.payload;
        },

        setGetExamPaperLoading: (state) => {
            state.getExamPaperLoading = true;
            state.getExamPaperSuccess = {};
            state.getExamPaperError = '';
        },
        setGetExamPaperSuccess: (state, action) => {
            state.getExamPaperLoading = false;
            state.getExamPaperSuccess = action.payload;
            state.getExamPaperError = '';
        },
        setGetExamPaperError: (state, action) => {
            state.getExamPaperLoading = false;
            state.getExamPaperSuccess = {};
            state.getExamPaperError = action.payload;
        },

        resetDetails: (state) => {
            state.getExamPaperSuccess = {};
        },
    }
})

export const { setExamPaperListLoading, setExamPaperListSuccess, setExamPaperListError,
    setGetExamPaperLoading, setGetExamPaperSuccess, setGetExamPaperError, resetDetails} = examPaperSlice.actions;


export default examPaperSlice.reducer;